<template>
    <div class="alert" v-prevent-overscroll>

        <div class="alert-area">

            <div class="share-wrapper" :style="wrapperStyle">
                <div class="card-item" v-for="(item, index) in shareCardList" :key="index" :style="item.style" @click.stop="selectCard(item, index)">
                    <div class="card-item-border" :style="{borderColor: item.borderColor}"></div>
                    <img class="card-item-img" :src="item.holdCount ? item.cardHeadBrightImage : item.cardHeadImage" />
                    <div class="card-name" :style="item.nameStyle">{{item.prizeName}}</div>
                </div>

                <div class="share-activity" :style="shareActivityStyle"  @click.stop="shareActivity"></div>
                
                <div class="share-card" :style="shareCardStyle"  @click.stop="shareCard"></div>

            </div>

            <div class="close-area">
                <div class="close-border"></div>
                <img class="close-icon" :src="closeIconUrl" @click.stop="closeShareActivityCard" />
            </div>

        </div>

    </div>
</template>

<script>

let closeIcon = require('@/assets/imgs/close.png')

export default {

    name: 'shareActivityCard',

    props: {

        info: { // 分享卡片或者活动
            type: Object,
        },

    },

    inject: ['$$cardList'],

    computed: {

        $cardList() {
            return this.$$cardList()
        },

    },

    data() {

        return {

            closeIconUrl: closeIcon, // 关闭按钮样式

            shareCardList: [], // 分享卡片列表

            wrapperStyle: {}, // 包裹框样式

            shareActivityStyle: {}, // 分享活动样式

            shareCardStyle: {}, // 分享卡片样式

            selectedCard: {}, // 分享的卡片信息

        }

    },

    watch: {
        selectedCard: {
            handler(val) {
                let status = !!val.cardId
                this.toggleShareCardStyle(status)
            },
            deep: true
        }
    },

    mounted() {

        this.init()

    },

    methods: {

        init() {

            this.initStyle(this.info)

            this.initCardList(this.info)
        },

        initStyle(val) {

            let config = val && val.sharePopupConfig && val.sharePopupConfig

            let { popupConfig, shareActivity, shareCard } = config

            let transform = (config, imgKey, type) => {

                let options = {}

                if (config.position1 && config.position1.type) {
                    options[`${config.position1.type}`] =  `${config.position1.value || 0}px`
                }

                if (config.position2 && config.position2.type) {
                    options[`${config.position2.type}`] =  `${config.position2.value || 0}px`
                }
                
                if (config.width) {
                    options.width = `${config.width}px`
                }

                if (config.height) {
                    options.height = `${config.height}px`
                }

                if (imgKey) {
                    if (config[imgKey].url) {
                        let background = {
                            backgroundImage: `url(${config[imgKey].url})`,
                            backgroundSize: `100% 100%`,
                            backgroundPosition: '0px 0px',
                        }
                        options= Object.assign(options, background)
                    }
                }
            
                if (type === 'shareCard') {
                    let background = {
                        active: {
                            backgroundImage: `url(${config['activeImg'].url})`,
                            backgroundSize: `100% 100%`,
                            backgroundPosition: '0px 0px',
                        },
                        inactive: {
                            backgroundImage: `url(${config['inactiveImg'].url})`,
                            backgroundSize: `100% 100%`,
                            backgroundPosition: '0px 0px',
                        }
                    }
                    options= Object.assign(options, background)
                }

                return options
            }
            
            this.wrapperStyle = transform(popupConfig, 'img')
            this.shareActivityStyle = transform(shareActivity, 'img')
            let originalShareCardStyle = transform(shareCard, '', 'shareCard')
            originalShareCardStyle = Object.assign(originalShareCardStyle, originalShareCardStyle.inactive)
            this.shareCardStyle = originalShareCardStyle
        },

        initCardList(val) {
            let list = JSON.parse(JSON.stringify(this.$cardList))
           
            let configList = val.sharePopupConfig && val.sharePopupConfig.cardSelect && val.sharePopupConfig.cardSelect.configList
            let nameConfig =  val.sharePopupConfig && val.sharePopupConfig.cardText 
        
            let initItemStyle = (item) => {
                let options = {}
                if (item && item.position1 && item.position1.type) {
                    options[`${item.position1.type}`] =  `${item.position1.value || 0}px`
                }

                if (item && item.position2 && item.position2.type) {
                    options[`${item.position2.type}`] =  `${item.position2.value || 0}px`
                }
                
                if (item && item.width) {
                    options.width = `${item.width}px`
                }

                if (item && item.height) {
                    options.height = `${item.height}px`
                }

                return options
            }

            let initNameStyle = (config) => {
                let options = {}

                if (config && config.position1 && config.position1.type) {
                    options[`${config.position1.type}`] =  `${config.position1.value || 0}px`
                }

                if (config && config.position2 && config.position2.type) {
                    options[`${config.position2.type}`] =  `${config.position2.value || 0}px`
                }

                options.color      = config.color
                options.fontSize   = `${config.fontSize}px`
                options.textStroke = config.stroke ? `1px ${config.stroke}` : ''
                options.fontWeight = config.fontStyle.indexOf('bold') !== -1 ? 'bold' : ''
			    options.fontStyle  = config.fontStyle.indexOf('italic') !== -1 ? 'italic' : ''

                return options
            }
            
            list.forEach(item => {
                configList.forEach($item => {
                    if (item.cardId === $item.cardId) {
                        item = Object.assign(item, {$borderColor: $item.borderColor, borderColor: 'transparent'}, {style: initItemStyle($item), nameStyle: initNameStyle(nameConfig)})
                    }
                })
            })
            
            this.shareCardList = list

        },

        selectCard(e, i) { // 选择卡片
            if (!e.holdCount) {
                let txt = '还未点亮，暂不能选~'
                this.toast(txt)
            } else {
                this.selectedCard = e

                let list = this.shareCardList

                list.forEach((item, index) => {
                    if (index === i) {
                        this.$set(this.shareCardList[i], 'borderColor', item.$borderColor)
                    } else {
                        this.$set(this.shareCardList[index], 'borderColor', 'transparent')
                    }
                })
            }
        },

        toggleShareCardStyle(status) { // 切换状态
            let style =  this.shareCardStyle
            if (status) {
                style = Object.assign(style, style.active)
            }  else {
                style = Object.assign(style, style.inactive)
            }
            this.shareCardStyle = style
        },

        shareActivity() { // 分享活动
            this.$emit('emitEvent', {
                type: 'shareActivity',
                data: null,
                options: { type: 'activity' }
            })
            this.$emit('emitEvent', {
                type: 'closeShareActivityCard',
                data: null,
                options: null
            })
        },

        shareCard() { // 分享卡片
            let data = this.selectedCard
            if (!data.cardId) {
                return
            }
            this.$emit('emitEvent', {
                type: 'shareCard',
                data: this.generateValidateData(data),
                options: { type: 'card' }
            })
            this.$emit('emitEvent', {
                type: 'closeShareActivityCard',
                data: null,
                options: null
            })
        },

        generateValidateData(data) { // 生成数据项
            let list = JSON.parse(JSON.stringify(this.$cardList))
            for (let item of list) {
                if (item.cardId === data.cardId) {
                    return item
                }
            }
        },

        closeShareActivityCard() {
            this.$emit('emitEvent', {
                type: 'closeShareActivityCard',
                data: null,
                options: null
            })
        },

        toast(txt, duration) { // 封装统一的信息处理函数
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: duration || 2000
            })
        },


    }


}

</script>

<style lang="scss" scoped>
.alert {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.share-wrapper {
    position: relative;
}

.card-item,
.share-activity,
.share-card {
    position: absolute;
}

.card-item-border {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 100%;
    width: 100%;
    height: 100%;
    border: 3px solid transparent;
}

.card-item-img {
    width: 100%;
    height: 100%;
}

.card-name {
    position: absolute;
    width: 100%;
    text-align: center;
}

.close-area {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.close-border {
    border-left: 4px dashed #fff;
    height: 100px;
}

.close-icon {
    width: 68px;
    height: 68px;
}

</style>